import { getTableProductCategory } from 'actions'
import NotificationError from 'components/common/notificationsErrors'
import { Form, Formik, FormikProps } from 'formik'
import { getValidationSchema } from 'lib/FieldValidations'
import {
	IOptions,
	IPricesListsMassiveUpdateProductFormProps,
	IProductCategory
} from 'models/PricesListsMassiveUpdate'
import React, { Component, Fragment } from 'react'
import { Alert, Col, Row } from 'react-bootstrap'
import { TransProps, WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import PricesListsMassiveUpdateProductFormFields from './PricesListsMassiveUpdateProductFormFields'

interface IReduxProps {
	getTableProductCategory: (payload: IProductCategory) => void
	productCategory: IOptions
}
class PricesListsMassiveUpdateProductForm extends Component<
	IPricesListsMassiveUpdateProductFormProps &
		TransProps &
		WithTranslation &
		IReduxProps
> {
	componentDidMount = () => {
		this.props.getTableProductCategory({ incluye_todos: 1 })
	}

	render() {
		const { t, fields, handleOpenModal, selectedProducts, action } = this.props

		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		return (
			<Formik
				initialValues={{}}
				onSubmit={(values, actions) => {}}
				enableReinitialize={true}
				validationSchema={{ validationSchema }}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={action.code === '1' ? 'success' : 'danger'}>
								<b>{action.text}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center">
								<Col sm={11} className={'ml-3'}>
									<Row>
										{!_.isEmpty(fields) &&
											_.map(fields, (field) => {
												return (
													<Col sm={6}>
														<PricesListsMassiveUpdateProductFormFields
															field={field}
															formikProps={props}
															crudProps={this.props}
															handleOpenModal={handleOpenModal}
															selectedProducts={selectedProducts}
															initialValue={{}}
														/>
													</Col>
												)
											})}
									</Row>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls }: any) => {
	const { productCategory } = tableCalls
	return {
		productCategory
	}
}

const connectForm = connect(mapStateToProps, {
	getTableProductCategory
})(PricesListsMassiveUpdateProductForm)

export default withTranslation()(connectForm)
